import { defineMessages } from 'react-intl'

const messages = defineMessages({
  title: {
    id: 'page.serp.title',
  },
  description: {
    id: 'page.serp.description',
  },
})

export default messages
